(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4529],{

/***/ 82202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ g2_grid_report_cdp; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/NavigationBrand/index.ts + 3 modules
var NavigationBrand = __webpack_require__(22761);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../libs/templates/LogoTiles/index.ts + 1 modules
var LogoTiles = __webpack_require__(20442);
// EXTERNAL MODULE: ../../libs/templates/FooterCompact/index.ts + 2 modules
var FooterCompact = __webpack_require__(69524);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/G2GridReportCdp/components/Footer/Footer.tsx






var Footer = function Footer() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTiles/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterCompact/* default */.Z, {})]
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e11ayq6z0"
} : 0)("background:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

/* harmony default export */ var Footer_Footer = (Footer);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
;// CONCATENATED MODULE: ./src/views/G2GridReportCdp/components/RequestDemo/RequestDemo.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var data = {
  heading: "Interested in hearing more about how Segment can help you?",
  button: {
    text: "Request a demo"
  }
};

var RequestDemo = function RequestDemo() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* default */.ZP, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionContents, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCopyTextHeading, {
          tag: "h3",
          variant: "h2",
          children: data.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          size: "large",
          color: "primary",
          variant: "filled",
          tag: "a",
          href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
          children: data.button.text
        })]
      })
    })
  });
};

var StyledCopyTextHeading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Heading */.X6,  true ? {
  target: "e8vinz31"
} : 0)( true ? {
  name: "1s22u92",
  styles: "margin-bottom:32px"
} : 0);

var StyledSectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "e8vinz30"
} : 0)( true ? {
  name: "16oo1aq",
  styles: "max-width:684px;margin:0 auto"
} : 0);

/* harmony default export */ var RequestDemo_RequestDemo = (RequestDemo);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(23769);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ../../libs/matcha/components/Paper/index.ts + 2 modules
var Paper = __webpack_require__(16164);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ./src/views/G2GridReportCdp/components/Reviewers/Components/Card/Card.tsx


function Card_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var Card = function Card(_ref) {
  var description = _ref.description,
      author = _ref.author,
      authorAvatar = _ref.authorAvatar;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Paper/* default */.Z, {
    background: "transparent",
    borderRadius: 10,
    elevation: 2,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card_Wrapper, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDescription, {
        variant: "pMedium",
        children: description
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AccessoriesRow, {
        children: [authorAvatar && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Author, {
          alt: author,
          src: authorAvatar
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
          variant: "textBoldSmall",
          children: author
        })]
      })]
    })
  });
};

var Author = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "epvravr3"
} : 0)( true ? {
  name: "smq1r5",
  styles: "object-fit:cover;width:40px;height:40px;border-radius:50%;margin:0"
} : 0);

var AccessoriesRow = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "epvravr2"
} : 0)( true ? {
  name: "f2pz2c",
  styles: "display:flex;flex-wrap:wrap;align-items:center;justify-content:left;gap:8px"
} : 0);

var Card_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "epvravr1"
} : 0)( true ? {
  name: "knjsbg",
  styles: "padding:32px"
} : 0);

var StyledDescription = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "epvravr0"
} : 0)( true ? {
  name: "15bxtr0",
  styles: "margin-bottom:36px"
} : 0);

/* harmony default export */ var Card_Card = (Card);
;// CONCATENATED MODULE: ./src/views/G2GridReportCdp/components/Reviewers/Reviewers.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var copy = {
  heading: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: ["See why reviewers on", " ", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
      href: "https://www.g2.com/products/segment/reviews",
      target: "_blank",
      children: "G2"
    }), " ", "love Segment"]
  }),
  reviews: [{
    description: "\u201CExceptional product, with amazing support! I've been using Segment for a while now, and the product has delivered on the core promise every single time. Segment makes data collection incredibly easy. Thus businesses can benefit from the power of data at any stage of development. Not even mentioning the power of having data from various sources under one roof.\u201D",
    author: "Giorgi Shelia \u2014 Product Marketing"
  }, {
    description: "\u201CSegment is the perfect tool for combining user data across platforms and sources, which makes it possible to very quickly start extracting value from your datasets without first having to spend a huge amount of time and resources. The ability to easily identify users across their devices and different touch points has made it possible to visualize and analyze the entire digital customer journey from A to Z.\u201D",
    author: "Terje Sakariassen \u2014 Technical Project Manager"
  }, {
    description: "\u201CSegment has allowed us to level up our data game across every department. Segment allows me to get a great understanding of where data is coming from, and where it is flowing to. This allows me to make my data-based decisions far more confidently, as I am sure it is both coming from the right place & is accurate.\u201D",
    author: "Seth Erdman \u2014 Product Manager"
  }, {
    description: "\u201CThe tracking foundation for any SaaS, Segment is an infrastructure, a tracking framework and a data hub all at once. It has been the cornerstone of our product data and operational data operations since the very beginning. In essence, Segment makes everyone much more productive, tech and marketers alike.\u201D",
    author: "Gilles Bertaux \u2014 CEO"
  }]
};

var Reviewers = function Reviewers() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSectionBase, {
    variant: "centered",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
        centered: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          variant: "h2",
          children: copy.heading
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
        overrides: {
          xl: 2
        },
        children: copy.reviews.map(function (_ref, key) {
          var review = (0,esm_extends/* default */.Z)({}, _ref);

          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card_Card, _objectSpread({}, review), key);
        })
      })
    })]
  });
};

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e19md3qj0"
} : 0)(Section/* Wrapper */.im, "{padding-top:24px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("sm");
}, "{padding-top:40px;}}" + ( true ? "" : 0));

/* harmony default export */ var Reviewers_Reviewers = (Reviewers);
// EXTERNAL MODULE: ../../libs/utils/useScrollToAnchor/index.ts
var useScrollToAnchor = __webpack_require__(68714);
;// CONCATENATED MODULE: ./src/views/G2GridReportCdp/components/CustomersRankSegment/CustomersRankSegment.tsx


function CustomersRankSegment_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var CustomersRankSegment_data = {
  heading: "Customers rank Segment",
  columns: [{
    heading: "4 or 5",
    description: "Star rating from 500+ reviews"
  }, {
    heading: "90%",
    description: "Rate Segment as easy to use"
  }, {
    heading: "91%",
    description: "of Segment customers are likely to recommend"
  }],
  subheading: "Read the full report to see why.",
  button: {
    text: "Get the full report"
  }
};

var CustomersRankSegment = function CustomersRankSegment() {
  var scrollTo = (0,useScrollToAnchor/* default */.Z)("form-wrapper", -96);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CustomersRankSegment_StyledSectionBase, {
    variant: "centered",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSectionCopy, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
        centered: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          variant: "h2",
          children: CustomersRankSegment_data.heading
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledColumnTrack, {
        overrides: {
          md: 3
        },
        children: CustomersRankSegment_data.columns.map(function (_ref, index) {
          var heading = _ref.heading,
              description = _ref.description;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
            centered: true,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
              tag: "h3",
              variant: "h2",
              children: heading
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
              tag: "p",
              variant: "pLarge",
              children: description
            })]
          }, index);
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSubheading, {
          tag: "h3",
          variant: "h4",
          children: CustomersRankSegment_data.subheading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          size: "large",
          color: "primary",
          variant: "filled",
          tag: "a",
          onClick: scrollTo,
          children: CustomersRankSegment_data.button.text
        })]
      })
    })]
  });
};

var CustomersRankSegment_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ea9mwt63"
} : 0)(Section/* Wrapper */.im, "{padding-top:24px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("sm");
}, "{padding-top:40px;}}" + ( true ? "" : 0));

var StyledSubheading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Heading */.X6,  true ? {
  target: "ea9mwt62"
} : 0)( true ? {
  name: "1s22u92",
  styles: "margin-bottom:32px"
} : 0);

var StyledColumnTrack = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ColumnTrack/* default */.Z,  true ? {
  target: "ea9mwt61"
} : 0)( true ? {
  name: "pmdmf",
  styles: "width:100%;margin-top:56px"
} : 0);

var StyledSectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "ea9mwt60"
} : 0)( true ? {
  name: "1rxb0gn",
  styles: "max-width:1000px"
} : 0);

/* harmony default export */ var CustomersRankSegment_CustomersRankSegment = (CustomersRankSegment);
;// CONCATENATED MODULE: ./src/views/G2GridReportCdp/components/ComprehensiveG2/ComprehensiveG2.tsx


function ComprehensiveG2_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





var ComprehensiveG2_data = {
  heading: "In this comprehensive G2 Grid\xAE report on the CDP market, you\u2019ll get:",
  list: ["Detailed profiles and customer ratings of the top CDPs on G2", "Stack rankings of CDP vendors based on validated reviews from customers", "Customer scores based on ease of use, likelihood to recommend, support, and more"]
};

var ComprehensiveG2 = function ComprehensiveG2() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ComprehensiveG2_StyledSectionBase, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ComprehensiveG2_StyledSectionContents, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ComprehensiveG2_StyledCopyTextHeading, {
          tag: "h2",
          variant: "h2",
          children: ComprehensiveG2_data.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Ul, {
          children: ComprehensiveG2_data.list.map(function (item, index) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledListItem, {
              children: item
            }, index);
          })
        })]
      })
    })
  });
};

var ComprehensiveG2_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1jcbmss4"
} : 0)(Section/* Wrapper */.im, "{padding-top:24px;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("sm");
}, "{padding-top:40px;}}" + ( true ? "" : 0));

var ComprehensiveG2_StyledCopyTextHeading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Heading */.X6,  true ? {
  target: "e1jcbmss3"
} : 0)( true ? {
  name: "1s22u92",
  styles: "margin-bottom:32px"
} : 0);

var Ul = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "e1jcbmss2"
} : 0)( true ? {
  name: "1wz9pp9",
  styles: "padding-left:33px;display:grid"
} : 0);

var StyledListItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("li",  true ? {
  target: "e1jcbmss1"
} : 0)("font-weight:400;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.pMedium;
}, ";font-size:20px;" + ( true ? "" : 0));

var ComprehensiveG2_StyledSectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "e1jcbmss0"
} : 0)( true ? {
  name: "z9xs2w",
  styles: "max-width:844px;margin:0 auto"
} : 0);

/* harmony default export */ var ComprehensiveG2_ComprehensiveG2 = (ComprehensiveG2);
// EXTERNAL MODULE: ./src/views/G2GridReportCdp/components/Badges/assets/BadgeEnterprise@2x.png
var BadgeEnterprise_2x = __webpack_require__(20819);
var BadgeEnterprise_2x_default = /*#__PURE__*/__webpack_require__.n(BadgeEnterprise_2x);
;// CONCATENATED MODULE: ./src/views/G2GridReportCdp/components/Badges/assets/BadgeEnterprise.webp
/* harmony default export */ var BadgeEnterprise = ("data:image/webp;base64,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");
// EXTERNAL MODULE: ./src/views/G2GridReportCdp/components/Badges/assets/BadgeEnterprise@2x.webp
var assets_BadgeEnterprise_2x = __webpack_require__(51641);
var assets_BadgeEnterprise_2x_default = /*#__PURE__*/__webpack_require__.n(assets_BadgeEnterprise_2x);
// EXTERNAL MODULE: ./src/views/G2GridReportCdp/components/Badges/assets/BadgeMidMarket@2x.png
var BadgeMidMarket_2x = __webpack_require__(22845);
var BadgeMidMarket_2x_default = /*#__PURE__*/__webpack_require__.n(BadgeMidMarket_2x);
;// CONCATENATED MODULE: ./src/views/G2GridReportCdp/components/Badges/assets/BadgeMidMarket.webp
/* harmony default export */ var BadgeMidMarket = ("data:image/webp;base64,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");
// EXTERNAL MODULE: ./src/views/G2GridReportCdp/components/Badges/assets/BadgeMidMarket@2x.webp
var assets_BadgeMidMarket_2x = __webpack_require__(66495);
var assets_BadgeMidMarket_2x_default = /*#__PURE__*/__webpack_require__.n(assets_BadgeMidMarket_2x);
// EXTERNAL MODULE: ./src/views/G2GridReportCdp/components/Badges/assets/BadgeUnitedKingdom@2x.png
var BadgeUnitedKingdom_2x = __webpack_require__(16395);
var BadgeUnitedKingdom_2x_default = /*#__PURE__*/__webpack_require__.n(BadgeUnitedKingdom_2x);
;// CONCATENATED MODULE: ./src/views/G2GridReportCdp/components/Badges/assets/BadgeUnitedKingdom.webp
/* harmony default export */ var BadgeUnitedKingdom = ("data:image/webp;base64,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");
// EXTERNAL MODULE: ./src/views/G2GridReportCdp/components/Badges/assets/BadgeUnitedKingdom@2x.webp
var assets_BadgeUnitedKingdom_2x = __webpack_require__(9963);
var assets_BadgeUnitedKingdom_2x_default = /*#__PURE__*/__webpack_require__.n(assets_BadgeUnitedKingdom_2x);
// EXTERNAL MODULE: ./src/views/G2GridReportCdp/components/Badges/assets/BadgeEurope@2x.png
var BadgeEurope_2x = __webpack_require__(82296);
var BadgeEurope_2x_default = /*#__PURE__*/__webpack_require__.n(BadgeEurope_2x);
;// CONCATENATED MODULE: ./src/views/G2GridReportCdp/components/Badges/assets/BadgeEurope.webp
/* harmony default export */ var BadgeEurope = ("data:image/webp;base64,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");
// EXTERNAL MODULE: ./src/views/G2GridReportCdp/components/Badges/assets/BadgeEurope@2x.webp
var assets_BadgeEurope_2x = __webpack_require__(31139);
var assets_BadgeEurope_2x_default = /*#__PURE__*/__webpack_require__.n(assets_BadgeEurope_2x);
;// CONCATENATED MODULE: ./src/views/G2GridReportCdp/components/Badges/Badges.tsx


function Badges_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



















var BadgeEnterpriseImage = function BadgeEnterpriseImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat(BadgeEnterprise, ", ").concat((assets_BadgeEnterprise_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      src: (BadgeEnterprise_2x_default()),
      alt: "G2 badge: Enterprise Leader",
      width: "220",
      height: "260",
      loading: "lazy"
    })]
  });
};

var BadgeMidMarketImage = function BadgeMidMarketImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat(BadgeMidMarket, ", ").concat((assets_BadgeMidMarket_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      src: (BadgeMidMarket_2x_default()),
      alt: "G2 badge: Mid-Market Leader",
      width: "220",
      height: "260",
      loading: "lazy"
    })]
  });
};

var BadgeUnitedKingdomImage = function BadgeUnitedKingdomImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat(BadgeUnitedKingdom, ", ").concat((assets_BadgeUnitedKingdom_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      src: (BadgeUnitedKingdom_2x_default()),
      alt: "G2 badge: United Kingdom Leader",
      width: "220",
      height: "260",
      loading: "lazy"
    })]
  });
};

var BadgeEuropeImage = function BadgeEuropeImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat(BadgeEurope, ", ").concat((assets_BadgeEurope_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      src: (BadgeEurope_2x_default()),
      alt: "G2 badge: Europe Leader",
      width: "220",
      height: "260",
      loading: "lazy"
    })]
  });
};

var Badges_data = [{
  image: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BadgeEnterpriseImage, {}),
  title: "Enterprise Leader"
}, {
  image: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BadgeMidMarketImage, {}),
  title: "Mid-Market Leader"
}, {
  image: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BadgeUnitedKingdomImage, {}),
  title: "United Kingdom Leader"
}, {
  image: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BadgeEuropeImage, {}),
  title: "Europe Leader"
}];

var Badges = function Badges() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badges_StyledSectionBase, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badges_StyledColumnTrack, {
        columns: 2,
        overrides: {
          md: 4
        },
        children: Badges_data.map(function (_ref, index) {
          var image = _ref.image,
              title = _ref.title;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Badge, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTitle, {
              children: title
            }), image]
          }, index);
        })
      })
    })
  });
};

var Badges_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e10ofddk3"
} : 0)(Section/* Wrapper */.im, "{padding-top:24px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("sm");
}, "{padding-top:40px;}}" + ( true ? "" : 0));

var StyledTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e10ofddk2"
} : 0)(function (_ref3) {
  var theme = _ref3.theme;
  return theme.typography.textBoldSmall;
}, " color:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.twilio.gray[100];
}, ";", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.up("xl");
}, "{", function (_ref6) {
  var theme = _ref6.theme;
  return theme.typography.h5;
}, ";}" + ( true ? "" : 0));

var Badges_StyledColumnTrack = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ColumnTrack/* default */.Z,  true ? {
  target: "e10ofddk1"
} : 0)("gap:24px;max-width:1024px;margin:0 auto;", function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints.up("lg");
}, "{gap:48px;}" + ( true ? "" : 0));

var Badge = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e10ofddk0"
} : 0)( true ? {
  name: "1azakc",
  styles: "text-align:center"
} : 0);

/* harmony default export */ var Badges_Badges = (Badges);
// EXTERNAL MODULE: ./src/views/G2GridReportCdp/components/Testimonial/assets/TestimonialImage@2x.png
var TestimonialImage_2x = __webpack_require__(55637);
var TestimonialImage_2x_default = /*#__PURE__*/__webpack_require__.n(TestimonialImage_2x);
;// CONCATENATED MODULE: ./src/views/G2GridReportCdp/components/Testimonial/assets/TestimonialImage.webp
/* harmony default export */ var assets_TestimonialImage = ("data:image/webp;base64,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");
// EXTERNAL MODULE: ./src/views/G2GridReportCdp/components/Testimonial/assets/TestimonialImage@2x.webp
var assets_TestimonialImage_2x = __webpack_require__(58094);
var assets_TestimonialImage_2x_default = /*#__PURE__*/__webpack_require__.n(assets_TestimonialImage_2x);
;// CONCATENATED MODULE: ./src/views/G2GridReportCdp/components/Testimonial/Testimonial.tsx



function Testimonial_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Testimonial_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Testimonial_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Testimonial_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function Testimonial_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var Testimonial_data = {
  description: "\u201CSegment is a reliable customer data platform that helped us scale. Using Segment throughout the years has saved us the time required to connect and sync data between tools. Easiness of use, perfect documentation and the ability to debug events in Segment makes it the perfect tool.\"",
  author: "Daniel Korczynski \u2014 Head of Product, Enterprise"
};

var Testimonial = function Testimonial() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* default */.ZP, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial_Card, Testimonial_objectSpread({}, Testimonial_data))
    })
  });
};

var TestimonialImage = function TestimonialImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat(assets_TestimonialImage, ", ").concat((assets_TestimonialImage_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      src: (TestimonialImage_2x_default()),
      alt: "Illustration: Leader Spring 2023",
      width: "351",
      height: "264",
      loading: "lazy"
    })]
  });
};

var Testimonial_Card = function Card(_ref) {
  var avatar = _ref.avatar,
      description = _ref.description,
      author = _ref.author;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledPaper, {
    background: "transparent",
    borderRadius: 10,
    elevation: 2,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial_Wrapper, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopySlot, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, {
          tag: "p",
          variant: "pMedium",
          children: description
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial_AccessoriesRow, {
          children: [avatar && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial_Author, {
            alt: author,
            src: avatar
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AuthorName, {
            tag: "p",
            variant: "textBoldSmall",
            children: author
          })]
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageSlot, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TestimonialImage, {})
      })]
    })
  });
};

var ImageSlot = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1hzg9pp7"
} : 0)("grid-area:image;padding-top:16px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding-top:0;align-content:center;display:grid;}" + ( true ? "" : 0));

var StyledPaper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Paper/* default */.Z,  true ? {
  target: "e1hzg9pp6"
} : 0)( true ? {
  name: "1wayx3u",
  styles: "max-width:844px;width:100%;margin:0 auto;align-items:center"
} : 0);

var Testimonial_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1hzg9pp5"
} : 0)("display:grid;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("sm");
}, "{grid-template-areas:'image' 'copy';}", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("md");
}, "{grid-template-columns:1fr minmax(0, 351px);grid-template-areas:'copy image';}" + ( true ? "" : 0));

var CopySlot = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1hzg9pp4"
} : 0)("padding:16px 32px;grid-area:copy;", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.up("md");
}, "{padding:48px;}" + ( true ? "" : 0));

var Description = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1hzg9pp3"
} : 0)("color:", function (_ref6) {
  var theme = _ref6.theme;
  return theme.palette.twilio.gray[80];
}, ";margin-top:0;" + ( true ? "" : 0));

var Testimonial_Author = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "e1hzg9pp2"
} : 0)( true ? {
  name: "smq1r5",
  styles: "object-fit:cover;width:40px;height:40px;border-radius:50%;margin:0"
} : 0);

var AuthorName = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1hzg9pp1"
} : 0)(function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints.down("sm");
}, "{margin:16px 0;}" + ( true ? "" : 0));

var Testimonial_AccessoriesRow = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1hzg9pp0"
} : 0)( true ? {
  name: "f2pz2c",
  styles: "display:flex;flex-wrap:wrap;align-items:center;justify-content:left;gap:8px"
} : 0);

/* harmony default export */ var Testimonial_Testimonial = (Testimonial);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/templates/Forms/EmailCaptureForm/index.ts + 3 modules
var EmailCaptureForm = __webpack_require__(41948);
// EXTERNAL MODULE: ./src/views/G2GridReportCdp/components/Hero/assets/HeroImage@2x.png
var HeroImage_2x = __webpack_require__(7183);
var HeroImage_2x_default = /*#__PURE__*/__webpack_require__.n(HeroImage_2x);
// EXTERNAL MODULE: ./src/views/G2GridReportCdp/components/Hero/assets/HeroImage.webp
var assets_HeroImage = __webpack_require__(32531);
var HeroImage_default = /*#__PURE__*/__webpack_require__.n(assets_HeroImage);
// EXTERNAL MODULE: ./src/views/G2GridReportCdp/components/Hero/assets/HeroImage@2x.webp
var assets_HeroImage_2x = __webpack_require__(19392);
var assets_HeroImage_2x_default = /*#__PURE__*/__webpack_require__.n(assets_HeroImage_2x);
;// CONCATENATED MODULE: ./src/views/G2GridReportCdp/components/Hero/Hero.tsx











var Hero_copy = {
  overline: "Spring 2023 Report",
  heading: "The Leading Customer Data Platform",
  content: "Based on 500+ reviews, Segment is a top ranked CDP with 96% of users rating 4 or 5 stars, 91% customer recommendation rating, 90% ease of use score, and the largest market presence amongst all vendors"
};
var Hero_form = {
  formId: "g2-report-spring23",
  additionalTrackEvent: "Content Downloaded",
  overrideConsent: true,
  buttonText: "Get the report",
  successButtonText: "View the report",
  buttonUrl: "https://www.g2.com/reports/grid-report-for-customer-data-platform-cdp-spring-2023.embed?featured=segment&secure%5Bgated_consumer%5D=1d201e9d-4109-4b1d-b725-90f75200e092&secure%5Btoken%5D=6a42b7c038b0226567bdeb04b0584bd2d734edb44be9b0967806a5e6f7f69c77&utm_campaign=gate-1886689"
};

var Hero = function Hero() {
  var _useState = (0,react.useState)(false),
      isSubmitted = _useState[0],
      setIsSubmitted = _useState[1];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* default */.ZP, {
      variant: "2Col",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            tag: "h5",
            variant: "h5",
            children: Hero_copy.overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h1",
            variant: "h1",
            children: Hero_copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "p",
            variant: "pExtraLarge",
            children: Hero_copy.content
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormWrapper, {
          id: "form-wrapper",
          variant: isSubmitted ? "wide" : "narrow",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmailCaptureForm/* default */.Z, {
            resourceType: "report",
            customFormIdentifier: Hero_form.formId,
            additionalTrackEvent: Hero_form.additionalTrackEvent,
            overrideConsent: Hero_form.overrideConsent,
            buttonText: Hero_form.buttonText,
            successButtonText: Hero_form.successButtonText,
            buttonUrl: Hero_form.buttonUrl,
            onSubmit: function onSubmit() {
              return setIsSubmitted(true);
            },
            enableJobTitleField: true
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroImage, {})
      })]
    })
  });
};

var Hero_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "e5nv6ts1"
} : 0)("background:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.green[10];
}, ";" + ( true ? "" : 0));

var HeroImage = function HeroImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((HeroImage_default()), ", ").concat((assets_HeroImage_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      src: (HeroImage_2x_default()),
      alt: "Illustration: ".concat(Hero_copy.heading, "}"),
      width: "513",
      height: "515",
      loading: "lazy"
    })]
  });
};

var FormWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e5nv6ts0"
} : 0)("max-width:", function (_ref2) {
  var variant = _ref2.variant;
  return variant === "narrow" ? "417px" : "unset";
}, ";margin-top:38px;margin-bottom:32px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("lg");
}, "{margin-top:48px;margin-bottom:48px;}" + ( true ? "" : 0));

/* harmony default export */ var Hero_Hero = (Hero);
;// CONCATENATED MODULE: ./src/views/G2GridReportCdp/G2GridReportCdp.tsx















var G2GridReportCdpView = function G2GridReportCdpView() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: "G2: Spring 2023 Grid Report",
      pageDescription: "Based on 500+ reviews, Segment is a top ranked CDP with 96% of users rating 4 or 5 stars, 91% customer recommendation rating, 90% ease of use score, and the largest market presence amongst all vendors.",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationBrand/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial_Testimonial, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badges_Badges, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ComprehensiveG2_ComprehensiveG2, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomersRankSegment_CustomersRankSegment, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Reviewers_Reviewers, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RequestDemo_RequestDemo, {})]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer_Footer, {})]
    })
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e1fxjjb50"
} : 0)("background:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.neutrals.white[100];
}, ";" + ( true ? "" : 0));

/* harmony default export */ var G2GridReportCdp_G2GridReportCdp = (G2GridReportCdpView);
;// CONCATENATED MODULE: ./src/pages/g2-grid-report-cdp/index.tsx



var G2GridReportCdp = function G2GridReportCdp() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(G2GridReportCdp_G2GridReportCdp, {});
};

/* harmony default export */ var g2_grid_report_cdp = (G2GridReportCdp);

/***/ }),

/***/ 16164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Paper_Paper; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/matcha/components/Paper/Paper.views.tsx

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "etxif140"
} : 0)("background:", function (_ref) {
  var background = _ref.background;
  return background;
}, ";border-radius:", function (_ref2) {
  var borderRadius = _ref2.borderRadius;
  return borderRadius;
}, "px;border:", function (_ref3) {
  var border = _ref3.border;
  return border;
}, ";width:100%;height:100%;box-shadow:", function (_ref4) {
  var theme = _ref4.theme,
      elevation = _ref4.elevation;
  return theme.shadows[elevation];
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/Paper/Paper.tsx


var _excluded = ["background", "borderRadius", "border", "elevation", "children"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var Paper = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var background = _ref.background,
      _ref$borderRadius = _ref.borderRadius,
      borderRadius = _ref$borderRadius === void 0 ? 10 : _ref$borderRadius,
      _ref$border = _ref.border,
      border = _ref$border === void 0 ? "none" : _ref$border,
      _ref$elevation = _ref.elevation,
      elevation = _ref$elevation === void 0 ? 0 : _ref$elevation,
      children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, _objectSpread(_objectSpread({
    background: background || theme.palette.brand.boysenberry[100],
    borderRadius: borderRadius,
    border: border,
    elevation: elevation,
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
/* harmony default export */ var Paper_Paper = (Paper);
;// CONCATENATED MODULE: ../../libs/matcha/components/Paper/index.ts


/***/ }),

/***/ 90629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ UtilityNav_UtilityNav; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/utils/useMatchMedia/index.ts + 1 modules
var useMatchMedia = __webpack_require__(61093);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/useUtilityNavDescriptions.tsx




var useUtilityNavDescriptions = function useUtilityNavDescriptions(descriptions) {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var keys = (0,react.useMemo)(function () {
    if (!descriptions) return [];
    return Object.keys(descriptions);
  }, [descriptions]);
  var breakpointsKeys = Object.keys(theme.breakpoints.values);
  var sortedArrayOfKeys = (0,react.useMemo)(function () {
    return breakpointsKeys.filter(function (main) {
      return keys.some(function (key) {
        return key === main;
      });
    });
  }, [breakpointsKeys, keys]);

  var getNextKey = function getNextKey(key, index) {
    if (sortedArrayOfKeys[index - 1]) {
      var getIndexofCurrentKey = breakpointsKeys.indexOf(key);

      if (breakpointsKeys[getIndexofCurrentKey - 1] !== sortedArrayOfKeys[index - 1]) {
        return breakpointsKeys[breakpointsKeys.indexOf(key) - 1];
      }
    }

    return false;
  };

  var array = sortedArrayOfKeys.map(function (key, index) {
    var nextKey = getNextKey(key, index);
    var minWidth = sortedArrayOfKeys[index - 1] ? " and ".concat(theme.breakpoints.up(nextKey ? nextKey : key, false)) : "";
    var mediaString = "".concat(theme.breakpoints.down(key, false)).concat(minWidth);
    return (0,useMatchMedia/* default */.Z)(mediaString, true);
  });
  return descriptions[sortedArrayOfKeys[array.indexOf(true)]];
};

/* harmony default export */ var UtilityNav_useUtilityNavDescriptions = (useUtilityNavDescriptions);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/UtilityNav.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}



var StyledTypography = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e12rge5s2"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);
var StyledButtonText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ButtonText/* default */.Z,  true ? {
  target: "e12rge5s1"
} : 0)("padding-top:3px;margin:0 8px;font-size:", function (_ref) {
  var theme = _ref.theme;
  return theme.typography.buttonSmall;
}, ";&:after{height:1px;bottom:4px;}" + ( true ? "" : 0));
var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e12rge5s0"
} : 0)("width:100%;text-align:center;background:", function (_ref2) {
  var background = _ref2.background;
  return background;
}, ";padding:7px 17px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("xs");
}, "{padding:17px 40px;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/UtilityNav.tsx


var _excluded = ["announcement", "tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var UtilityNavBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var announcement = _ref.announcement,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var utilityNavDescriptions = "";

  if (typeof (announcement === null || announcement === void 0 ? void 0 : announcement.description) === "string") {
    utilityNavDescriptions = announcement.description;
  } else if (announcement !== null && announcement !== void 0 && announcement.description) {
    utilityNavDescriptions = UtilityNav_useUtilityNavDescriptions(announcement.description);
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    background: tokens.background,
    children: [utilityNavDescriptions && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTypography, {
      variant: "buttonSmall",
      children: utilityNavDescriptions
    }), announcement && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButtonText, {
      tokens: _objectSpread({}, tokens.buttonText),
      size: "small",
      href: announcement.ctaLink,
      hover: true,
      children: announcement.ctaTitle
    })]
  }));
});
var UtilityNav = (0,useDesignTokens/* withDesignTokens */.Y)(UtilityNavBase, function () {
  return {};
}, {
  twilioLight: function twilioLight(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  },
  light: function light(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  },
  dark: function dark(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  }
});
/* harmony default export */ var UtilityNav_UtilityNav = (UtilityNav);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/index.ts


/***/ }),

/***/ 22761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ NavigationBrand_NavigationBrand; }
});

// EXTERNAL MODULE: ../../libs/matcha/components/Media/index.ts + 2 modules
var Media = __webpack_require__(75091);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/index.ts + 3 modules
var UtilityNav = __webpack_require__(90629);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/index.ts + 30 modules
var Navigation_MobileNavigation = __webpack_require__(86943);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/Navbar/index.ts + 8 modules
var Navbar = __webpack_require__(90806);
// EXTERNAL MODULE: ../../libs/tracking/scripts/index.ts + 2 modules
var scripts = __webpack_require__(17397);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/NavigationBrand/MobileNavigation.tsx








var MobileNavigation = function MobileNavigation(_ref) {
  var announcement = _ref.announcement,
      backgroundColor = _ref.backgroundColor;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Navigation_MobileNavigation/* default */.ZP, {
    children: [announcement && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UtilityNav/* default */.Z, {
      announcement: announcement
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* Navbar */.wp, {
      tokens: {
        backgroundColor: backgroundColor
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navbar/* Brand */.H2, {
        href: "/",
        onClick: function onClick() {
          return (0,scripts/* trackButtonClick */.kO)({
            buttonText: "Segment Logo",
            targetUrl: "/",
            buttonCampaign: "nav"
          });
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
          alt: "Twilio, Inc."
        })
      })
    })]
  });
};

/* harmony default export */ var NavigationBrand_MobileNavigation = (MobileNavigation);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Navbar/index.ts + 14 modules
var DesktopNavigation_Navbar = __webpack_require__(77966);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/index.ts + 24 modules
var DesktopNavigation = __webpack_require__(82680);
;// CONCATENATED MODULE: ../../libs/templates/NavigationBrand/DesktopNavigation.tsx







var DesktopNavigation_MobileNavigation = function MobileNavigation(_ref) {
  var announcement = _ref.announcement,
      backgroundColor = _ref.backgroundColor;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DesktopNavigation/* default */.ZP, {
    children: [announcement && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavigation/* UtilityNav */.T8, {
      announcement: announcement
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavigation/* Navbar */.wp, {
      tokens: {
        backgroundColor: backgroundColor
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavigation_Navbar/* Brand */.H2, {
        href: "/",
        onClick: function onClick() {
          return (0,scripts/* trackButtonClick */.kO)({
            buttonText: "Segment Logo",
            targetUrl: "/",
            buttonCampaign: "nav"
          });
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
          alt: "Twilio, Inc."
        })
      })
    })]
  });
};

/* harmony default export */ var NavigationBrand_DesktopNavigation = (DesktopNavigation_MobileNavigation);
;// CONCATENATED MODULE: ../../libs/templates/NavigationBrand/NavigationBrand.tsx






var NavigationBrand = function NavigationBrand(_ref) {
  var announcement = _ref.announcement,
      backgroundColor = _ref.backgroundColor;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Media/* default */.Z, {
      greaterThanOrEqual: "md",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationBrand_DesktopNavigation, {
        backgroundColor: backgroundColor,
        announcement: announcement
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Media/* default */.Z, {
      lessThan: "md",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationBrand_MobileNavigation, {
        backgroundColor: backgroundColor,
        announcement: announcement
      })
    })]
  });
};
/* harmony default export */ var NavigationBrand_NavigationBrand = (NavigationBrand);
;// CONCATENATED MODULE: ../../libs/templates/NavigationBrand/index.ts


/***/ }),

/***/ 85807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useInView; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useInView/useInView.ts

/**
 * A hook to observe elements in the viewport
 * @param ref - A ref to the element to observe
 * @param options - The options for the IntersectionObserver
 * @returns A boolean indicating if the element is in the viewport
 */

var useIsInView = function useIsInView(ref) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$stopOnIntersecti = _ref.stopOnIntersection,
      stopOnIntersection = _ref$stopOnIntersecti === void 0 ? true : _ref$stopOnIntersecti,
      options = _ref.options;

  var _useState = (0,react.useState)(false),
      isInView = _useState[0],
      setIsInView = _useState[1];

  var inViewRef = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    var intersectionObserver = new IntersectionObserver(function (intersection) {
      if (intersection.some(function (i) {
        return i.isIntersecting;
      })) {
        inViewRef.current = true;
        setIsInView(true);

        if (stopOnIntersection) {
          intersectionObserver.disconnect();
        }
      } else if (inViewRef.current) {
        inViewRef.current = false;
        setIsInView(false);
      }
    }, options);

    if (ref.current) {
      intersectionObserver.observe(ref.current);
    }

    return function () {
      intersectionObserver.disconnect();
    };
  }, [ref]);
  return isInView;
};

/* harmony default export */ var useInView = (useIsInView);
;// CONCATENATED MODULE: ../../libs/utils/useInView/index.ts


/***/ }),

/***/ 64816:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/g2-grid-report-cdp",
      function () {
        return __webpack_require__(82202);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 20819:
/***/ (function(module) {

module.exports = "/_next/static/images/BadgeEnterprise@2x-51bb3b8a11c3092b36bd8db09a47522e.png";

/***/ }),

/***/ 82296:
/***/ (function(module) {

module.exports = "/_next/static/images/BadgeEurope@2x-84c9d4a9535c5155218e680a6856a2ee.png";

/***/ }),

/***/ 22845:
/***/ (function(module) {

module.exports = "/_next/static/images/BadgeMidMarket@2x-60e434bb31be19cae28b5c814affa774.png";

/***/ }),

/***/ 16395:
/***/ (function(module) {

module.exports = "/_next/static/images/BadgeUnitedKingdom@2x-71c5c700e1c7fbe15b9274407cb310ca.png";

/***/ }),

/***/ 7183:
/***/ (function(module) {

module.exports = "/_next/static/images/HeroImage@2x-feaefe64fc506ecfe4705c999090b58c.png";

/***/ }),

/***/ 55637:
/***/ (function(module) {

module.exports = "/_next/static/images/TestimonialImage@2x-d914aaedb85d9041abd5607829bd92cf.png";

/***/ }),

/***/ 51641:
/***/ (function(module) {

module.exports = "/_next/static/images/BadgeEnterprise@2x-743c763aeea09d0906fe7c44b2781167.webp";

/***/ }),

/***/ 31139:
/***/ (function(module) {

module.exports = "/_next/static/images/BadgeEurope@2x-7f5e32b06227e5e5af43e0a6c0c44506.webp";

/***/ }),

/***/ 66495:
/***/ (function(module) {

module.exports = "/_next/static/images/BadgeMidMarket@2x-a622b7bc535965cf0c29e057609c5c38.webp";

/***/ }),

/***/ 9963:
/***/ (function(module) {

module.exports = "/_next/static/images/BadgeUnitedKingdom@2x-175fdf26bb522cf9eac7e09196795704.webp";

/***/ }),

/***/ 32531:
/***/ (function(module) {

module.exports = "/_next/static/images/HeroImage-c28d2488b50d1f57d939c2fa41fb8bde.webp";

/***/ }),

/***/ 19392:
/***/ (function(module) {

module.exports = "/_next/static/images/HeroImage@2x-50118a2641c4a14595d5f76e03db9664.webp";

/***/ }),

/***/ 58094:
/***/ (function(module) {

module.exports = "/_next/static/images/TestimonialImage@2x-5b9ef6126c40687457d7060a4473e6a2.webp";

/***/ }),

/***/ 23769:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,9137,3254,9129,1382,4136,2073,4274,7096,2429,1367,948,3996,8726,7960,6012,442,9524,9774,2888,179], function() { return __webpack_exec__(64816); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);